import styled from 'styled-components'

type Gap = 'small' | 'normal' | 'big' | number

interface Props {
  gap?: Gap
}
export const SimpleGrid = styled.div<Props>`
  display: grid;
  grid-gap: ${props => getGap(props)};
  justify-items: center;
`

function getGap({ gap }: Props): string {
  let size = 10
  if (!gap) {
    gap = 'normal'
  }
  switch (gap) {
    case 'small':
      size = 5
      break
    case 'normal':
      size = 10
      break
    case 'big':
      size = 20
      break
  }
  return `${size}px`
}
